import EXTERNAL_SEARCH_CONFIG from '@/app/config/search'
import { SearchClient } from 'instantsearch.js'
import Typesense from 'typesense'
import TypesenseInstantSearchAdapter, {
  TypesenseInstantsearchAdapterOptions,
} from 'typesense-instantsearch-adapter'
import { ConfigurationOptions } from 'typesense/lib/Typesense/Configuration'

export const getSearchClient = (
  apiKey: string,
  options?: Omit<TypesenseInstantsearchAdapterOptions, 'server'> & {
    server?: Partial<TypesenseInstantsearchAdapterOptions['server']>
  }
) => {
  const config = {
    ...options,
    server: {
      apiKey,
      sendApiKeyAsQueryParam: false,
      nodes: EXTERNAL_SEARCH_CONFIG.nodes,
      cacheSearchResultsForSeconds: 2 * 60, // Cache search results from server. Defaults to 2 minutes. Set to 0 to disable caching.
      ...(options?.server ?? {}),
    },
    additionalSearchParameters: {
      ...(options?.additionalSearchParameters ?? {}),
    },
  }

  return new TypesenseInstantSearchAdapter(config).searchClient as SearchClient
}

export function getServerSideTypesenseClient(
  apiKey: string,
  options?: Partial<ConfigurationOptions>
) {
  return new Typesense.Client({
    nodes: EXTERNAL_SEARCH_CONFIG.nodes,
    apiKey,
    numRetries: 3,
    connectionTimeoutSeconds: 10,
    logLevel: 'error',
    ...options,
  })
}
